import api from './api';
import requester from './requester';

const publicHolidays = {
    fetchAgencyPublicHolidays: (agencyId, userId, role) => requester(api.agencyPublicHolidays(agencyId, userId, role)).getOne(),
    fetchEmployeePublicHolidays: (agencyId, employeeId) => requester(api.employeePublicHolidays(agencyId, employeeId)).getOne(),
};

export default publicHolidays;
